import { connect } from 'react-redux';
import Navbar from './navbar';
import { navigate } from '../reducers/navigator.reducers';

const mapStateToProps = state => ({
  loggedIn: state.authentication.loggedIn
});

const mapDispatchToProps = dispatch => ({
  navigateTo: (routeName) => dispatch(navigate({route: routeName})),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/app/navbar_new/navbar.container.js